module.exports = __webpack_public_path__ + "img/electrical_circuit.af7690ca.png";